import React from "react";
import PropTypes from "prop-types";
// create a table reuseable component
const Table = ({ dataRow, thead }) => {
  return (
    <table className="w-full ">
      <thead className="bg-[#F4F4F4] rounded  py-2">
        <tr className="">
          {thead.map((column, index) => (
            <th
              className="text-center whitespace-nowrap px-6 py-5 md:text-sm text-xs font-normal rounded-l-lg"
              key={index}
            >
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{dataRow}</tbody>
    </table>
  );
};

// set up prop types for the table component
Table.propTypes = {
  dataRow: PropTypes.array.isRequired,
  th: PropTypes.any.isRequired,
};

export default Table;
